export default {"src":"/_next/static/media/payment-visa-icon.ab2cc5f0.svg","height":20,"width":29};